import { useToast } from "@/components/ui/use-toast"

export function Toaster() {
  const { toasts } = useToast()

  // Render nothing - using Sonner's Toaster from the Layout
  return null
}